import { render, staticRenderFns } from "./ResourcePlanning.vue?vue&type=template&id=0fb2f56a&scoped=true"
import script from "./ResourcePlanning.vue?vue&type=script&lang=js"
export * from "./ResourcePlanning.vue?vue&type=script&lang=js"
import style0 from "./ResourcePlanning.vue?vue&type=style&index=0&id=0fb2f56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2f56a",
  null
  
)

export default component.exports